/* Doladowywanie kolejnych stron kolekcji przy przewijaniu (22.09.2026).

   Nie buduje wlasnego pobierania - klika istniejacy przycisk "Pokaz wiecej",
   ktory obsluguje `filters.js`. Dzieki temu jest jedna sciezka ladowania:
   ta sama obsluga bledow, ta sama aktualizacja adresu, to samo zachowanie
   przy wlaczonych filtrach.

   WAZNE: dziala tylko razem z bezpiecznikiem `dataset.zwiazany` w `filters.js`.
   Bez niego `bind()` dokladalby kolejny listener po kazdym doladowaniu, wszystkie
   odpalalyby `updateQuery()` i licznik stron przeskakiwalby o kilka naraz -
   przy 12 stronach realnie ladowaly sie tylko 1, 2, 3, 5, 8 i 12.

   Wyzwalaczy sa dwa, bo sam IntersectionObserver nie wystarcza: przy skokowym
   zjechaniu na dol (klawisz End, przeciagniecie paska, stopka wyzsza niz okno)
   przycisk potrafi minac pasmo wyzwalania i wyladowac nad krawedzia widoku.
   Dlatego to samo sprawdzenie wisi tez na dlawionym `scroll`.

   `AUTO_MAX` bylo `Infinity` i to wywalalo Safari na iPhonie (zgloszenie
   klienta 22.09.2026). Najwieksza kolekcja ma 251 produktow, czyli 16 stron
   po 16. Kazdy kafel to dwa zdjecia po 640 px szerokosci, a iOS trzyma je
   zdekodowane w pamieci tak dlugo, jak wisza w drzewie dokumentu - `loading`
   `="lazy"` powstrzymuje tylko pobranie, nie zwalnia tego, co juz przewinelismy.
   Jedno machniecie palcem doladowywalo wszystkie strony naraz: ~500 bitmap,
   grubo ponad gigabajt, i Safari ubijalo karte ("A problem repeatedly
   occurred").

   Stad twardy limit: po AUTO_MAX doladowaniach robote przejmuje przycisk
   "Pokaz wiecej", czyli dalsze strony sa juz swiadoma decyzja czlowieka,
   a nie skutkiem ubocznym przewijania. Przy okazji znika stary koszt opisany
   wyzej - stopka jest osiagalna bez przemielenia calej kolekcji.

   Gdyby trzeba bylo to kiedys przestawic, `content-visibility` na kaflach
   (`section-listing.css`) zdejmuje czesc obciazenia w Safari 18+, ale nie na
   starszych iPhonach, wiec limit musi zostac. */
(function () {
  var AUTO_MAX = 3; /* 3 doladowania = 64 produkty, potem przycisk */
  var ZAPAS = 300; /* px przed krawedzia okna, zeby kafle byly juz na miejscu */
  var zrobione = 0;
  var obserwator = null;
  var czekaNaKlatke = false;

  function przycisk() {
    return document.querySelector('.listing [data-load-more]');
  }

  /* `filters.js` znaczy listing klasa `loading` na czas pobierania - bez tego
     sprawdzenia kliknelibysmy drugi raz, zanim pierwsza strona doszla. */
  function trwaLadowanie() {
    var listing = document.querySelector('.listing');
    return !!listing && listing.classList.contains('loading');
  }

  /* Jedyne miejsce decydujace o doladowaniu. `top < okno + ZAPAS` lapie
     przycisk zblizajacy sie od dolu, a ujemne `top` - przycisk juz miniety. */
  function sprawdz() {
    if (zrobione >= AUTO_MAX || trwaLadowanie()) return;
    var btn = przycisk();
    if (!btn) return;
    if (btn.getBoundingClientRect().top > window.innerHeight + ZAPAS) return;
    zrobione += 1;
    btn.click();
  }

  function naPrzewijaniu() {
    if (czekaNaKlatke) return;
    czekaNaKlatke = true;
    requestAnimationFrame(function () {
      czekaNaKlatke = false;
      sprawdz();
    });
  }

  function podepnij() {
    if (obserwator) {
      obserwator.disconnect();
      obserwator = null;
    }

    var btn = przycisk();
    if (!btn || zrobione >= AUTO_MAX) return;

    obserwator = new IntersectionObserver(function (wpisy) {
      wpisy.forEach(function (wpis) {
        if (wpis.isIntersecting) sprawdz();
      });
    }, { rootMargin: ZAPAS + 'px 0px' });

    obserwator.observe(btn);
    sprawdz(); /* przycisk moze byc w kadrze juz w chwili podpiecia */
  }

  /* Zmiana filtrow podmienia caly `[data-listing]`, wiec przycisk bywa nowym
     elementem - obserwator trzeba wtedy podpiac od nowa. */
  function pilnujListingu() {
    var listing = document.querySelector('[data-listing]');
    if (!listing) return;
    var czeka = null;
    new MutationObserver(function () {
      clearTimeout(czeka);
      czeka = setTimeout(podepnij, 100);
    }).observe(listing, { childList: true, subtree: true });
  }

  function start() {
    if (!document.querySelector('.listing')) return;
    podepnij();
    pilnujListingu();
    window.addEventListener('scroll', naPrzewijaniu, { passive: true });
    window.addEventListener('resize', naPrzewijaniu, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
